import { render } from "./StafetDeltagSomFighterStepTwo.vue?vue&type=template&id=77c5b5af"
import script from "./StafetDeltagSomFighterStepTwo.vue?vue&type=script&lang=js"
export * from "./StafetDeltagSomFighterStepTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__